export const MENSAGEM = {
    TIPO: {
        SUCESSO: 'success',
        ERRO: ' error',
        INFO: 'info',
        ALERTA: 'alert',
        PERGUNTA: 'question',
    },
    TAMANHO: {
        EXTRA_PEQUENO: ' btn-xs',
        PEQUENO: ' btn-sm',
        MEDIO: '',
        GRANDE: ' btn-lg',
        EXTRA_GRANDE: ' btn-xl'
    }
}

export const BOTAO = {
    COR: {
        PRIMARIO: ' btn-primary',
        SECUNDARIO: ' btn-secondary',
        SUCESSO: ' btn-success',
        INFO: ' btn-info',
        PERIGO: ' btn-danger',
        ALERTA: ' btn-warning'
    },
    TAMANHO: {
        EXTRA_PEQUENO: ' btn-xs',
        PEQUENO: ' btn-sm',
        MEDIO: '',
        GRANDE: ' btn-lg',
        EXTRA_GRANDE: ' btn-xl'
    }
}

export const ICONE = {
    MARGEM_PADRAO: ' mr-2',
    TIPO: {
        ABRIR: 'bi bi-folder2-open',
        ADICIONAR: 'bi bi-plus-circle',
        ALTERAR: 'bi bi-pencil',
        CANCELAR: 'bi bi-times-circle',
        EDITAR: 'bi bi-pencil',
        ENVIAR: 'bi bi-paper-plane',
        ERRO: 'bi bi-times-circle',
        EXCLUIR: 'bi bi-trash3-fill',
        FECHAR: 'bi bi-x-circle',
        INFO: 'bi bi-info-circle',
        IMPRIMIR: 'bi bi-printer',
        LIMPAR: 'bi bi-undo-alt',
        OK: 'bi bi-check-circle',
        PDF: 'bi bi-file-pdf',
        PESQUISAR: 'bi bi-search',
        SALVAR: 'bi bi-save',
        TRANSFERIR: 'bi bi-arrow-left-right',
        VOLTAR: 'bi bi-arrow-bar-left',
    }
}


